import { render, staticRenderFns } from "./voucher.list.vue?vue&type=template&id=1a55b18a&"
import script from "./voucher.list.vue?vue&type=script&lang=js&"
export * from "./voucher.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports